export const SortBy = {
  POST_CREATED: 'post_created',
} as const;

export type SortByType = (typeof SortBy)[keyof typeof SortBy];
